import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  CoreService,
  DialogResult,
  DialogService,
  DspxCardSetBaseFormComponent,
  SpinnerService
} from "dspx-core";
import { BaseCardSetListComponent } from "../base-card-set-list-component/base-card-set-list.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ResponseParserService } from "../../services/response-parser.service";
import { AppDataService } from "../../services/app-data.service";
import { ErrorService } from "../../services/error.service";
import { TEMPLATES } from "../../constants/templates.constants";
import { API_ENDPOINTS } from "../../constants/api-endpoints.constants";
import { CareAllowancePlacementBulkAdHocInvoiceQueryGridFilterRequest } from "../../interfaces/care-allowance-placement-bulk-ad-hoc-invoice-query-grid-filter-request.interface";
import {
  FILTER_QUESTION_CODES,
  NAV_TAB_NUMBERS,
  PAGE_NUMBERS,
  POP_UP_CODES,
  POP_UP_STYLE_CLASS,
  QUESTION_CODES,
  SAVE_RESULT_STATUS,
  SECTION_CODES
} from "../../constants/app-data.constants";
import { Mapper, MapperBuilder } from "../../helpers/mapper";
import { nameof } from "../../helpers/nameof";
import { ROUTE_CONSTANTS } from "../../constants/route.constants";
import { finalize, take } from "rxjs";
import { CareAllowanceBulkAdHocInvoiceQueryPlacementListResponse } from "../../interfaces/care-allowance-bulk-ad-hoc-invoice-query-placement-list-response";
import { JobSaveRequest } from "../../models/job-save-request";

@Component({
  selector: 'app-care-allowance-placement-bulk-ad-hoc-invoice-query-list',
  templateUrl: './care-allowance-placement-bulk-ad-hoc-invoice-query-list.component.html',
  styleUrl: './care-allowance-placement-bulk-ad-hoc-invoice-query-list.component.scss'
})
export class CareAllowancePlacementBulkAdHocInvoiceQueryListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {

  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';
  private routePrefix = '';
  private description = '';

  filterQuestionToFilterModelMapper: Mapper;
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.careAllowancePlacementBulkAdHocInvoiceQueryList,
      () => {
        return API_ENDPOINTS.dashboard.getCareAllowancePlacementBulkAdHocInvoiceQueries
      },
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementBulkAdHocInvoiceQueryList.description, null, nameof<CareAllowancePlacementBulkAdHocInvoiceQueryGridFilterRequest>('description'))
        .BuildMapper();
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.careAllowancePlacementBulkAdHocInvoiceQueryListForm.bulkAdHocInvoiceQueryGridFilter:
      {
        const applicationFilterRequest = this.getBulkAdHocInvoiceQueryFilterRequest();
        this.loadGridData(applicationFilterRequest);
        break;
      }
    }
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_new_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.prefix]);
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.prefix, event.event.data.id]);
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_view_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacementBulkAdHocInvoiceQuery.prefixViewQuery, event.event.data.id]);
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_delete_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.confirmDelete;
    this.registerSubscription(
      this.dialogService.showConfirm(this.activeDialog)
        .pipe(take(1))
        .subscribe((response) => {
          if (response === DialogResult.ACCEPTED) {
            this.spinnerService.showSpinner()
            const endpoint = API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.delete;
            this.appDataService.post(endpoint, { bulkAdHocInvoiceQueryId: event.event.data.id })
              .pipe(
                take(1),
                this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner())
              )
              .subscribe(data => {
                if (data?.status === SAVE_RESULT_STATUS.success) {
                  this.reloadPage();
                }
              });
          }
        })
    );
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_approve_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.confirmApprove;
    this.registerSubscription(
      this.dialogService
        .showConfirm(this.activeDialog)
        .subscribe((response) => {
          if (response === DialogResult.ACCEPTED) {
            this.spinnerService.showSpinner();
            const endpoint = API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.approvePlacementList;
            this.appDataService.post(endpoint,{ bulkAdHocInvoiceQueryId: event.event.data.id } )
              .pipe(
                take(1),
                this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner())
              )
              .subscribe(data => {
                if (data?.status === SAVE_RESULT_STATUS.success) {
                  this.reloadPage();
                }
              });
          }
        })
    );
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_placementList_Clicked(event: any) {
    this.showPlacementListAsync(event.event.data.id);
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_run_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.confirmRunQuery;
    this.registerSubscription(
      this.dialogService.showConfirm(this.activeDialog)
        .pipe(take(1))
        .subscribe((response) => {
          if (response === DialogResult.ACCEPTED) {
            this.spinnerService.showSpinner();
            const endpoint = API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.runQueryPlacementsLink;
            this.appDataService.post(endpoint,{ bulkAdHocQueryId: event.event.data.id } )
              .pipe(
                take(1),
                this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner())
              )
              .subscribe(data => {
                if (data?.status === SAVE_RESULT_STATUS.success) {
                  this.reloadPage();
                }
              });
          }
        })
    );
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_generateInvoices_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.confirmGenerateInvoices;
    this.dialogService.showConfirm(this.activeDialog)
      .pipe(take(1))
      .subscribe((response) => {
        if (response === DialogResult.ACCEPTED) {
          this.spinnerService.showSpinner();
          this.runAdHocJob(event.event.data.jobTypeId, event.event.data.id);
        }
      });
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_reRunErroredInvoices_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.confirmReRunErroredInvoices;
    this.dialogService.showConfirm(this.activeDialog)
      .pipe(take(1))
      .subscribe((response) => {
        if (response === DialogResult.ACCEPTED) {
          this.spinnerService.showSpinner();
          this.runAdHocJob(event.event.data.jobTypeId, event.event.data.id);
        }
      });
  }

  actionButton_bulkAdHocInvoiceQueryGrid_datagrid_custom_refresh_Clicked(event: any) {
    this.reloadPage();
  }

  private runAdHocJob(jobTypeId: string, jobScheduleId: string) {
    const endpoint = API_ENDPOINTS.job.runAdHoc;
    let request = new JobSaveRequest();
    request.jobTypeId = jobTypeId;
    request.jobScheduleId = jobScheduleId;
    this.registerSubscription(
      this.appDataService.post(endpoint, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage();
          }
        })
    );
  }

  private getBulkAdHocInvoiceQueryFilterRequest(): CareAllowancePlacementBulkAdHocInvoiceQueryGridFilterRequest {
    let filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.bulkAdHocInvoiceQueryGridFilter.bulkAdHocInvoiceQuery,
      PAGE_NUMBERS.bulkAdHocInvoiceQueryGridFilter.bulkAdHocInvoiceQuery,
      SECTION_CODES.bulkAdHocInvoiceQueryGridFilter.bulkAdHocInvoiceQuerySection,
      QUESTION_CODES.careAllowancePlacementBulkAdHocInvoiceQueryListForm.bulkAdHocInvoiceQueryGridFilter
    );
    const mappedFilters = this.filterQuestionToFilterModelMapper.Map(filterModel)
    return mappedFilters;
  }

  private async showPlacementListAsync(bulkAdHocQueryId: any) {
    const response: CareAllowanceBulkAdHocInvoiceQueryPlacementListResponse = await this.getPlacementListAsync(bulkAdHocQueryId);
    if (response != null) {
      const messagePlaceholders = {
        recordCount: response.recordCount,
        totalInvoiceAmount: response.totalInvoiceAmount
      };

      const popupModel = {
        'placementGrid-totalRecords': response.gridData.length,
        'placementGrid': response.gridData
      };

      this.dialogService.showDialog(POP_UP_CODES.careAllowancePlacementBulkAdHocInvoiceQuery.placements, popupModel, messagePlaceholders, true, POP_UP_STYLE_CLASS.dialogXl);
    }
  }

  private async getPlacementListAsync(bulkAdHocQueryId: any) {
    this.spinnerService.showSpinner();
    let data: any;
    data = await this.appDataService
      .postAndFetchData(`${API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.getPlacementList}/${bulkAdHocQueryId}`)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .toPromise();
    return data;
  }
}
